export interface CastMember {
  name: string;
  role: string;
}

export interface Actor {
  id: string;
  name: string;
  avatar: string;
  bio: string;
}

export interface MediaItem {
  id: string;
  title: string;
  type: 'tv' | 'movie';
  typeLabel: string;
  region: string;
  year: number;
  genres: string[];
  tags: string[];
  rating: number;
  scoreLevel: 'highest' | 'high' | 'medium';
  cover: string;
  summary: string;
  synopsis: string;
  director: string;
  cast: CastMember[];
  episodes: string;
  updatedAt: string;
  heat: number;
}

export const actors: Actor[] = [
  {
    id: 'a1',
    name: '张知远',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20middle%20aged%20chinese%20male%20detective%20actor%20with%20calm%20eyes%20warm%20neutral%20beige%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-01&orientation=squarish',
    bio: '以沉稳内敛的表演风格著称，擅长塑造深沉复杂的悬疑与年代剧角色，被观众称为「眼神会演戏」的实力派。',
  },
  {
    id: 'a2',
    name: '林晚晴',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20young%20chinese%20female%20actress%20with%20gentle%20expression%20warm%20peach%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-02&orientation=squarish',
    bio: '文艺片出身的青年女演员，气质清透，擅长演绎细腻克制的情感戏，多次入围年度新人奖项。',
  },
  {
    id: 'a3',
    name: '陈子墨',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20chinese%20male%20action%20actor%20with%20sharp%20features%20warm%20grey%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-03&orientation=squarish',
    bio: '动作与犯罪题材的常客，身手利落、情绪张力十足，是近年商业类型片最抢眼的面孔之一。',
  },
  {
    id: 'a4',
    name: '苏绿',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20elegant%20chinese%20female%20actress%20in%20traditional%20style%20warm%20cream%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-04&orientation=squarish',
    bio: '兼具古典与灵气的气质型演员，古装与现代剧皆能驾驭，尤擅长演绎温柔而坚韧的女性角色。',
  },
  {
    id: 'a5',
    name: '赵景行',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20rugged%20chinese%20male%20character%20actor%20with%20weathered%20face%20warm%20earth%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-05&orientation=squarish',
    bio: '从话剧舞台走向银幕的性格演员，擅长刻画市井小人物与沉默寡言的硬汉形象，辨识度极高。',
  },
  {
    id: 'a6',
    name: '李念之',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20cheerful%20young%20chinese%20female%20actress%20with%20bright%20smile%20warm%20pink%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-06&orientation=squarish',
    bio: '以治愈系角色收获大量人气的青年演员，笑容明亮，擅长演绎温暖日常中的细腻情绪。',
  },
  {
    id: 'a7',
    name: '王梓豪',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20energetic%20chinese%20young%20male%20actor%20with%20confident%20look%20warm%20sand%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-07&orientation=squarish',
    bio: '新生代人气演员，动作与青春题材双线发展，可塑性极强，被媒体评为「最有冲劲的少年感」。',
  },
  {
    id: 'a8',
    name: '周落雁',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20confident%20chinese%20female%20actress%20with%20short%20hair%20warm%20taupe%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-08&orientation=squarish',
    bio: '干练利落的都市女性角色代言人，台词功底扎实，擅长演绎理性冷静的职业女性。',
  },
  {
    id: 'a9',
    name: 'Emily Carter',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20international%20female%20actress%20with%20determined%20gaze%20warm%20neutral%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-09&orientation=squarish',
    bio: '活跃于国际科幻与悬疑题材的女演员，气质冷静坚毅，常被塑造成团队中的关键决策者。',
  },
  {
    id: 'a10',
    name: 'James Reed',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20international%20male%20actor%20with%20strong%20jaw%20warm%20graphite%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-10&orientation=squarish',
    bio: '建筑与表演双学位的实力派，沉稳的低音与克制表演让他在科幻大片中格外有分量。',
  },
  {
    id: 'a11',
    name: '金泰河',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20korean%20male%20actor%20with%20soft%20melancholic%20look%20warm%20beige%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-11&orientation=squarish',
    bio: '以都市情感剧积累口碑的韩国演员，表演含蓄细腻，擅长诠释压抑而深情的角色。',
  },
  {
    id: 'a12',
    name: '高桥悠',
    avatar:
      'https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20fictional%20japanese%20male%20actor%20with%20quiet%20dignity%20warm%20off%20white%20background%20soft%20cinematic%20lighting%20editorial%20headshot%20no%20text%20high%20detail&width=400&height=400&seq=actor-12&orientation=squarish',
    bio: '日本资深演员，作品横跨电影与电视剧，善于用极少的台词传递厚重的情绪。',
  },
];

export const mediaList: MediaItem[] = [
  {
    id: '1',
    title: '雾都黎明',
    type: 'tv',
    typeLabel: '电视剧',
    region: '中国大陆',
    year: 2024,
    genres: ['悬疑', '犯罪', '剧情'],
    tags: ['高能反转', '刑侦', '高分神剧'],
    rating: 9.1,
    scoreLevel: 'highest',
    cover:
      'https://readdy.ai/api/search-image?query=moody%20cinematic%20poster%20art%20of%20a%20foggy%20old%20town%20at%20dawn%20with%20a%20lone%20detective%20silhouette%20muted%20crimson%20and%20amber%20tones%20dramatic%20volumetric%20light%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-01&orientation=portrait',
    summary: '迷雾笼罩的旧城区连环案，一位老刑警与年轻搭档在真相与谎言间步步逼近。',
    synopsis:
      '旧城接连发生手法相似的离奇案件，退休又被返聘的老刑警与初来乍到的年轻搭档被迫组队。两人在层层迷雾中梳理线索，却发现案件背后牵涉到二十年前一桩被刻意掩盖的旧事。随着调查深入，真相与谎言交织，每个人都藏着不愿被揭开的秘密。',
    director: '沈砚舟',
    cast: [
      { name: '张知远', role: '饰 老刑警 周维新' },
      { name: '陈子墨', role: '饰 刑警 陆骁' },
      { name: '周落雁', role: '饰 法医 白露' },
    ],
    episodes: '全 32 集',
    updatedAt: '2024-09-18',
    heat: 9860,
  },
  {
    id: '2',
    title: '海边的信号塔',
    type: 'movie',
    typeLabel: '电影',
    region: '中国大陆',
    year: 2023,
    genres: ['剧情', '文艺'],
    tags: ['治愈', '海边', '口碑佳作'],
    rating: 8.2,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20an%20isolated%20seaside%20lighthouse%20at%20golden%20dusk%20gentle%20waves%20and%20warm%20peach%20sky%20minimal%20composition%20soft%20film%20grain%20melancholic%20mood%20no%20text%20high%20detail&width=600&height=800&seq=poster-02&orientation=portrait',
    summary: '守塔人的女儿回到海边小镇，用一台旧收音机重新听见父亲与故乡的声音。',
    synopsis:
      '离家多年的女孩回到即将拆除的海边信号塔，替父亲处理最后的交接。她在阁楼里找到一台还能工作的旧收音机，一遍遍收听着陌生又熟悉的电波。随着与小镇居民重新熟络，她逐渐理解了父亲当年为何执意留守，也找到了自己与故乡之间那条从未真正断开的线。',
    director: '许南屿',
    cast: [
      { name: '林晚晴', role: '饰 程晚' },
      { name: '赵景行', role: '饰 老渔民 阿海' },
      { name: '李念之', role: '饰 电台记者 小满' },
    ],
    episodes: '片长 118 分钟',
    updatedAt: '2023-11-05',
    heat: 6420,
  },
  {
    id: '3',
    title: '长安十二辰',
    type: 'tv',
    typeLabel: '电视剧',
    region: '中国大陆',
    year: 2025,
    genres: ['古装', '历史', '悬疑'],
    tags: ['大制作', '国风美学', '年度期待'],
    rating: 9.3,
    scoreLevel: 'highest',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20ancient%20chinese%20lantern%20lit%20palace%20street%20at%20night%20ornate%20red%20lanterns%20and%20silk%20banners%20warm%20amber%20glow%20epic%20historical%20atmosphere%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-03&orientation=portrait',
    summary: '一夜之间，京城命案频发，不良人与大理寺少卿在十二个时辰内联手破局。',
    synopsis:
      '盛唐夜色之下，一场足以动摇朝局的阴谋悄然展开。出身市井的不良人与冷峻的大理寺少卿被卷入同一桩疑案，他们必须在十二个时辰之内找出真相。案情步步升级，朝堂与江湖的势力交错纠缠，两人在信任与怀疑之间艰难前行。',
    director: '顾长风',
    cast: [
      { name: '王梓豪', role: '饰 不良人 裴十三' },
      { name: '苏绿', role: '饰 舞姬 云舒' },
      { name: '张知远', role: '饰 大理寺少卿 崔明' },
    ],
    episodes: '全 40 集',
    updatedAt: '2025-01-22',
    heat: 12040,
  },
  {
    id: '4',
    title: '星轨之外',
    type: 'movie',
    typeLabel: '电影',
    region: '美国',
    year: 2024,
    genres: ['科幻', '冒险'],
    tags: ['硬科幻', '视觉奇观', '太空'],
    rating: 8.7,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20poster%20art%20of%20a%20lone%20astronaut%20facing%20a%20giant%20ringed%20planet%20deep%20orange%20nebula%20and%20warm%20dust%20dramatic%20scale%20contrast%20cinematic%20lighting%20no%20text%20high%20detail&width=600&height=800&seq=poster-04&orientation=portrait',
    summary: '一次失联的深空任务，让一名宇航员在星轨之外面对人类文明最艰难的抉择。',
    synopsis:
      '一支深空探测队在执行常规采样任务时与地球失去联系。唯一清醒的宇航员在孤独的航行中逐渐发现，舱内记录与自己的记忆出现了出入。当飞船上最后一段影像被解开，他必须在返航与继续前进之间做出选择——而无论哪个选择，都将改变人类对宇宙的理解。',
    director: 'Nathan Cole',
    cast: [
      { name: 'James Reed', role: '饰 宇航员 艾略特' },
      { name: 'Emily Carter', role: '饰 舰长 诺兰' },
      { name: '王梓豪', role: '饰 工程师 林越' },
    ],
    episodes: '片长 142 分钟',
    updatedAt: '2024-07-30',
    heat: 9230,
  },
  {
    id: '5',
    title: '首尔夜行',
    type: 'tv',
    typeLabel: '电视剧',
    region: '韩国',
    year: 2024,
    genres: ['都市', '爱情', '剧情'],
    tags: ['氛围感', '都市治愈', '高分爱情'],
    rating: 8.0,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20rainy%20neon%20lit%20seoul%20street%20at%20night%20with%20two%20silhouettes%20under%20one%20umbrella%20warm%20pink%20and%20amber%20reflections%20romantic%20mood%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-05&orientation=portrait',
    summary: '一个写不出下一本书的作家，和一家通宵花店的老板娘，在雨夜的城市里相遇。',
    synopsis:
      '陷入创作停滞的作家每夜在首尔的街头游荡，直到偶然走进一家只在深夜营业的花店。寡言的老板娘、来来往往的客人、以及那些被雨水打湿的心事，慢慢填满了他空白的手稿。两个各自带着过去的人，在这座不眠的城市里学会了重新开始。',
    director: '郑夏准',
    cast: [
      { name: '金泰河', role: '饰 作家 姜在勋' },
      { name: '李念之', role: '饰 花店老板 尹素拉' },
      { name: '赵景行', role: '饰 常客 老朴' },
    ],
    episodes: '全 16 集',
    updatedAt: '2024-06-12',
    heat: 8710,
  },
  {
    id: '6',
    title: '雪国列车长',
    type: 'movie',
    typeLabel: '电影',
    region: '日本',
    year: 2023,
    genres: ['剧情', '悬疑'],
    tags: ['公路电影', '人性', '催泪'],
    rating: 8.5,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20winter%20train%20crossing%20a%20snowy%20mountain%20pass%20cold%20white%20landscape%20with%20warm%20cabin%20light%20mysterious%20atmosphere%20soft%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-06&orientation=portrait',
    summary: '暴雪封路的最后一班列车，一位老列车长要在脱轨前找出混在乘客中的秘密。',
    synopsis:
      '年末的最后一班列车遭遇罕见暴雪，被迫停在无人的山间小站。即将退休的老列车长发现，车厢里一名乘客的身份并不简单，而这场风雪也远比想象中凶险。在有限的燃料与时间里，他必须在真相与职责之间做出判断，护送所有人抵达终点。',
    director: '中村航',
    cast: [
      { name: '高桥悠', role: '饰 列车长 佐藤' },
      { name: '苏绿', role: '饰 乘客 林芷' },
      { name: '赵景行', role: '饰 记者 陈默' },
    ],
    episodes: '片长 126 分钟',
    updatedAt: '2023-12-20',
    heat: 7840,
  },
  {
    id: '7',
    title: '十七楼的夏天',
    type: 'tv',
    typeLabel: '电视剧',
    region: '中国大陆',
    year: 2024,
    genres: ['青春', '校园', '剧情'],
    tags: ['青春', '成长', '夏日限定'],
    rating: 7.9,
    scoreLevel: 'medium',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20bright%20summer%20afternoon%20on%20a%20school%20rooftop%20warm%20sunlight%20and%20gentle%20breeze%20nostalgic%20youth%20atmosphere%20pastel%20peach%20tones%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-07&orientation=portrait',
    summary: '高三那年夏天，十七楼的天台上记录了四个少年最莽撞也最勇敢的成长。',
    synopsis:
      '高考前的最后一个夏天，四个性格迥异的少年因为一张天台的钥匙走到一起。他们分享心事、偷偷练习、也为未来焦虑迷茫。当离别的钟声逼近，每个人都不得不直面自己想成为的样子。这是一段关于勇气、友情与悄然萌芽心动的青春故事。',
    director: '苏晓棠',
    cast: [
      { name: '周落雁', role: '饰 林一夏' },
      { name: '王梓豪', role: '饰 学长 顾城' },
      { name: '李念之', role: '饰 闺蜜 微微' },
    ],
    episodes: '全 24 集',
    updatedAt: '2024-08-01',
    heat: 6980,
  },
  {
    id: '8',
    title: '追风者',
    type: 'movie',
    typeLabel: '电影',
    region: '中国大陆',
    year: 2024,
    genres: ['动作', '赛车'],
    tags: ['燃爆', '赛车', '视觉大片'],
    rating: 8.3,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20sleek%20sports%20car%20drifting%20on%20a%20coastal%20road%20at%20sunset%20motion%20blur%20and%20flying%20dust%20warm%20orange%20sky%20high%20energy%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-08&orientation=portrait',
    summary: '退役赛车手为替兄弟洗清冤屈，重返赛道挑战一场没有规则的地下竞速。',
    synopsis:
      '曾经的天才赛车手因一场事故退出赛道，从此隐姓埋名。当昔日挚友被卷入一场地下竞速的阴谋，他被迫重握方向盘。面对更快的对手、更险的弯道和无处不在的算计，他要在速度与理智之间找到那条通往真相的线路。',
    director: '杜鸣',
    cast: [
      { name: '陈子墨', role: '饰 车手 江野' },
      { name: '林晚晴', role: '饰 领航员 沈知' },
      { name: '赵景行', role: '饰 对手 老K' },
    ],
    episodes: '片长 110 分钟',
    updatedAt: '2024-10-02',
    heat: 8120,
  },
  {
    id: '9',
    title: '伦敦迷雾',
    type: 'tv',
    typeLabel: '电视剧',
    region: '英国',
    year: 2023,
    genres: ['推理', '悬疑', '犯罪'],
    tags: ['英伦', '推理', '烧脑'],
    rating: 8.9,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20foggy%20victorian%20london%20street%20with%20gas%20lamps%20and%20a%20mysterious%20silhouette%20muted%20amber%20and%20grey%20tones%20moody%20detective%20atmosphere%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-09&orientation=portrait',
    summary: '浓雾弥漫的伦敦街头，一桩看似普通的失窃案，牵出跨越三个街区的地下谜团。',
    synopsis:
      '一位以冷静著称的警探接手了一桩平平无奇的失窃案，却在现场发现了不合常理的细节。随着调查推进，线索把她引向城市地下错综复杂的网络，以及一群彼此牵连的陌生人。雾气之下，每个人都戴着面具，而解开谜题的钥匙藏在最不起眼的角落。',
    director: 'Oliver Hayes',
    cast: [
      { name: 'Emily Carter', role: '饰 警探 艾琳' },
      { name: 'James Reed', role: '饰 嫌疑人 托马斯' },
      { name: '张知远', role: '饰 目击者 老陈' },
    ],
    episodes: '全 8 集',
    updatedAt: '2023-09-14',
    heat: 7640,
  },
  {
    id: '10',
    title: '深空回声',
    type: 'movie',
    typeLabel: '电影',
    region: '美国',
    year: 2025,
    genres: ['科幻', '惊悚'],
    tags: ['太空惊悚', '密闭空间', '高能'],
    rating: 8.4,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20derelict%20space%20station%20corridor%20with%20faint%20warm%20emergency%20light%20deep%20darkness%20and%20tension%20sci%20fi%20horror%20mood%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-10&orientation=portrait',
    summary: '废弃空间站里突然响起的回声，让救援小队意识到他们并不是唯一的来者。',
    synopsis:
      '一支救援小队登上失联多年的空间站，试图回收珍贵的导航数据。空荡的舱道里传来规律的敲击声，与他们自己的脚步声并不完全重合。当队员逐一失联，指挥官发现这艘船上的「回声」似乎拥有自己的意图，而返回的路线正在一段段消失。',
    director: 'Nathan Cole',
    cast: [
      { name: 'James Reed', role: '饰 指挥官 罗恩' },
      { name: 'Emily Carter', role: '饰 通讯官 凯拉' },
      { name: '王梓豪', role: '饰 工程师 林越' },
    ],
    episodes: '片长 108 分钟',
    updatedAt: '2025-02-14',
    heat: 9020,
  },
  {
    id: '11',
    title: '山海食堂',
    type: 'tv',
    typeLabel: '电视剧',
    region: '中国大陆',
    year: 2025,
    genres: ['治愈', '美食', '剧情'],
    tags: ['治愈系', '深夜食堂', '烟火气'],
    rating: 8.6,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20cozy%20little%20tavern%20kitchen%20with%20steaming%20dishes%20and%20warm%20lantern%20light%20rustic%20wooden%20interior%20comforting%20atmosphere%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-11&orientation=portrait',
    summary: '巷子深处一家只在黄昏开门的小食堂，用一道道家常菜接住每个疲惫的归人。',
    synopsis:
      '小食堂的老板话不多，却记得每一位常客的口味。深夜加班的白领、刚失恋的姑娘、背着行囊的旅人，都能在这里点上一份属于自己的热菜。随着故事在一张张餐桌间展开，这间不起眼的小店，成了许多人重新出发的起点。',
    director: '林知味',
    cast: [
      { name: '李念之', role: '饰 店主 陈小满' },
      { name: '张知远', role: '饰 常客 老周' },
      { name: '苏绿', role: '饰 学徒 阿念' },
    ],
    episodes: '全 20 集',
    updatedAt: '2025-03-08',
    heat: 8360,
  },
  {
    id: '12',
    title: '银翼猎手',
    type: 'movie',
    typeLabel: '电影',
    region: '中国香港',
    year: 2024,
    genres: ['动作', '犯罪', '悬疑'],
    tags: ['港片', '飙车枪战', '双雄'],
    rating: 8.1,
    scoreLevel: 'high',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20stylish%20rooftop%20chase%20above%20a%20glowing%20harbour%20city%20at%20night%20dramatic%20silhouettes%20and%20warm%20city%20lights%20crime%20thriller%20mood%20film%20grain%20no%20text%20high%20detail&width=600&height=800&seq=poster-12&orientation=portrait',
    summary: '一名固执的警察与一名神秘线人，在霓虹夜色中追查一桩跨城走私大案。',
    synopsis:
      '码头的一通匿名举报，让一桩沉寂多年的走私案重新浮出水面。被停职的警察与身份不明的线人被迫结成临时搭档，他们穿梭于霓虹与旧巷之间，一面躲避追杀，一面逼近真相。当信任成为唯一的筹码，谁才是真正站在自己这边的人？',
    director: '麦子豪',
    cast: [
      { name: '陈子墨', role: '饰 警察 高远' },
      { name: '王梓豪', role: '饰 线人 阿骏' },
      { name: '周落雁', role: '饰 记者 苏晴' },
    ],
    episodes: '片长 116 分钟',
    updatedAt: '2024-11-16',
    heat: 7580,
  },
];

export const regionOptions: string[] = [
  '全部地区',
  '中国大陆',
  '美国',
  '韩国',
  '日本',
  '英国',
  '中国香港',
];

export const yearOptions: string[] = ['全部年份', '2025', '2024', '2023'];

export const genreOptions: string[] = [
  '全部类型',
  '悬疑',
  '犯罪',
  '剧情',
  '古装',
  '历史',
  '科幻',
  '都市',
  '爱情',
  '青春',
  '校园',
  '动作',
  '推理',
  '惊悚',
  '治愈',
  '美食',
];

export const quickTags: string[] = ['高能反转', '治愈系', '大制作', '烧脑', '燃爆', '复古港风'];